import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var CheckCircle = function CheckCircle(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.9893 23.3516C18.0801 23.3516 23.1074 18.3242 23.1074 12.2441C23.1074 6.16406 18.0693 1.13672 11.9785 1.13672C5.89844 1.13672 0.881836 6.16406 0.881836 12.2441C0.881836 18.3242 5.90918 23.3516 11.9893 23.3516ZM10.7861 17.5508C10.3779 17.5508 10.0449 17.3789 9.74414 16.9814L7.1123 13.791C6.91895 13.5439 6.82227 13.2969 6.82227 13.0283C6.82227 12.4697 7.2627 12.0186 7.82129 12.0186C8.1543 12.0186 8.41211 12.1367 8.69141 12.4912L10.7539 15.1016L15.1797 8.01172C15.416 7.63574 15.7168 7.45312 16.0605 7.45312C16.6084 7.45312 17.1025 7.8291 17.1025 8.39844C17.1025 8.64551 16.9736 8.91406 16.8232 9.15039L11.7852 16.9814C11.5488 17.3574 11.1943 17.5508 10.7861 17.5508Z"
  })));
};

CheckCircle.displayName = 'CheckCircle';
export default CheckCircle;